import { Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { AccommodationService } from './../../services/accommodation.service';
import { Validators } from '@angular/forms';
import { DVFormControl, DVFormGroup } from './../../../shared/helpers/dynamic-validators/dynamic-validator';
import { Component, OnInit, OnChanges } from '@angular/core';

@Component({
  selector: 'app-assign-life-experience',
  templateUrl: './assign-life-experience.component.html',
  styleUrls: ['./assign-life-experience.component.css']
})
export class AssignLifeExperienceComponent implements OnInit {
  assignForm: DVFormGroup;

  experiences = [];
  locals = [];
  accommodations = [];

  selectedCityId = undefined;

  constructor(
    private accommodationService: AccommodationService,
    private notifier: SnotifyService,
    private router: Router) {

    this.assignForm = new DVFormGroup({

      experienceId: new DVFormControl(null, {
        'Experience is required': Validators.required
      }),
      localId: new DVFormControl(null, {
        'Local is required': Validators.required
      }),
      accommodationId: new DVFormControl(null, {
        'Accommodation is required': Validators.required
      }),

    });
  }

  ngOnInit() {
    this.onChanges();
    this.loadExperiences();

  }

  SubmitForm() {
    if (this.assignForm.invalid) {
      this.assignForm.forceShowErrors();
      return
    }
    const data = {
      localId: this.assignForm.value.localId,
      accommodationId: +this.assignForm.value.accommodationId
    }

    this.accommodationService.assignLifeExperience(this.assignForm.value.experienceId, data).subscribe(res => {
      this.notifier.success('Assigned Life Experience Successfully');
      this.router.navigateByUrl('/accommodations/list');
    },
      err => {
        this.notifier.error(err.error.userMessage);
      })
  }

  onChanges(): void {
    this.assignForm.get('experienceId').valueChanges.subscribe(val => {

      if (val) {
        this.selectedCityId = this.experiences.find(e => e.id == val).cityId;
        this.loadLocalsByCityId();
        this.loadAccommodationByCityId();
      }
      else {
        this.selectedCityId = undefined;
      }
    })
  }

  loadExperiences() {
    this.accommodationService.getAllExperience().subscribe(res => {
      this.experiences = [];
      this.experiences = res.data.experiences;
    });
  }

  loadLocalsByCityId() {
    this.accommodationService.getLocalsByCityId(this.selectedCityId).subscribe(res => {
      this.locals = [];
      this.locals = res.data.locals;
    });
  }

  loadAccommodationByCityId() {
    this.accommodationService.getAccommodationsByCityId(this.selectedCityId).subscribe(res => {
      this.accommodations = [];
      this.accommodations = res.data.accommodations;
    });
  }

}
